export const ACCOUNT_TYPES = {
  Admin: "Admin",
  Business: "Business",
}
